<template>
  <section class="fold-equity-table well">
    <header class="page-header">
      <h1>Fold equity vs. various ranges</h1>
    </header>
    <p>The immediately profitable breakeven percentage for a {{ state.bluffSize }} pot bluff is <strong>{{ immediatelyProfitableBreakevenPercentage }}%</strong>. However, you probably don't need the full {{ immediatelyProfitableBreakevenPercentage }}%. You can drop it down by about 5-15% or so depending on things like how many outs you have (<a href="#should-you-bluff-final-conclusion">see further down</a>). What breakeven percentage do you want to use?</p>
    <div class="form-group">
      <label>
        True breakeven percentage:
        <input
          type="number"
          class="form-control input-lg"
          v-bind:value="state.profitableBreakevenPercentage"
          v-on:input="$emit('setProfitableBreakevenPercentage', $event.target.valueAsNumber)"
          min="1"
          v-bind:max="immediatelyProfitableBreakevenPercentage"
        >
      </label>
    </div>
    <p v-if="cutoffHand">The "flipping point" occurs with <strong>{{ cutoffHand.inlineText }}</strong>. If you think that you can get folds from {{ cutoffHand.inlineText }} and worse, your bluff will be profitable. If you don't, your bluff won't be profitable.</p>
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Range they're folding</th>
          <th>Fold equity</th>
          <th>Required fold equity - fold equity</th>
        </tr>
      </thead>
      <tbody v-if="tableExpanded">
        <tr v-for="{ rangeTheyreFolding, foldEquity, diff } in foldEquityAgainstDifferentRanges">
          <td>{{ rangeTheyreFolding }}</td>
          <td>{{ foldEquity }}%</td>
          <td v-bind:class="getDiffClass(diff)">{{ diff }}%</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr v-for="{ rangeTheyreFolding, foldEquity, diff } in condensedFoldEquityAgainstDifferentRanges">
          <td>{{ rangeTheyreFolding }}</td>
          <td>{{ foldEquity }}%</td>
          <td v-bind:class="getDiffClass(diff)">{{ diff }}%</td>
        </tr>
      </tbody>
    </table>
    <button
      class="btn btn-default"
      v-on:click="tableExpanded = !tableExpanded"
    >
      <span v-if="tableExpanded">Collapse <span class="glyphicon glyphicon-minus"></span></span>
      <span v-else>Expand <span class="glyphicon glyphicon-plus"></span></span>
    </button>
  </section>
</template>

<script>
export default {
  name: 'fold-equity-table',
  props: ['state', 'playerStateIndex', 'immediatelyProfitableBreakevenPercentage'],
  data: function () {
    return {
      tableExpanded: false,
    };
  },
  computed: {
    playerState: function () {
      return this.state.players.find(0).states[this.playerStateIndex];
    },
    cutoffHand: function () {
      return this.playerState.getCutoffHandForBluffing(this.state.profitableBreakevenPercentage);
    },
    foldEquityAgainstDifferentRanges: function () {
      return this.playerState.foldEquityAgainstDifferentRanges.map(function ({ cutoffHand, foldEquity }) {
        return {
          rangeTheyreFolding: `${cutoffHand.fullText} and worse`,
          foldEquity: foldEquity,
          diff: (foldEquity - this.state.profitableBreakevenPercentage).roundToTwoDecimalPlaces(),
        };
      }, this);
    },
    condensedFoldEquityAgainstDifferentRanges: function () {
      let condensedFoldEquityAgainstDifferentRanges = this.playerState.getCondensedFoldEquityAgainstDifferentRanges(this.state.profitableBreakevenPercentage);

      return condensedFoldEquityAgainstDifferentRanges.map(function ({ cutoffHand, foldEquity }) {
        return {
          rangeTheyreFolding: `${cutoffHand.fullText} and worse`,
          foldEquity: foldEquity,
          diff: (foldEquity - this.state.profitableBreakevenPercentage).roundToTwoDecimalPlaces(),
        };
      }, this);
    },
  },
  watch: {
    cutoffHand: function (newVal) {
      if (!newVal) {
        this.tableExpanded = true;
      }
    },
  },
  created: function () {
    if (!this.cutoffHand) {
      this.tableExpanded = true;
    }
  },
  methods: {
    getDiffClass: function (diff) {
      return `diff-${Math.floor(diff)}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "src/assets/grid-square-shades";

  .fold-equity-table {
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/guided-analyses/should-you-bluff/conclusions/fold-equity-table.vue